export enum WallComponent {
  CadInsertWall = 'cad-insert-wall', // Use a cad file to fill the area of a rectangular wall.
  Default = 'default',
  GlassPanels = 'glass-panels',
  Shutter = 'shutter',
  PorchRailing = 'porch-railing',
  SlidingGlassDoor = 'sliding-glass-door',
  SlidingGlassDoorWithGrid = 'sliding-glass-door-with-grid',
  DeckingBoard = 'decking-board',
  NoWall = 'no-wall',
}
